import type { DefaultRootState } from "react-redux";
export * from "ce/selectors/dataTreeCyclicSelectors";

export const getCurrentEnvironmentName = (state: DefaultRootState) =>
  state.environments.currentEnvironmentDetails.name || "";
